<script>
export default {
  name: "safeScoreSelector",
  props: {
    inputsDisabled: Boolean,
    safeScoreRatingError: Boolean,
    safeScoreCommentError: Boolean,
    safeScoreData: Object
  },
  data() {
    return {
      safeScore: {grade: '', comment1: '', comment2: '', comment3: '', comment4: '', comment5: ''}
    }
  },
  methods: {
    resize(textAreaRef) {
      let vm = this;
      let element = vm.$refs[textAreaRef];
      element.style.height = "18px";
      element.style.height = element.scrollHeight + "px";
    },
  },
  watch: {
    safeScore: {
      handler(newValue) {
        let vm = this,
            emitionObj = {rating: newValue.grade, comment: ''};

        switch (vm.safeScore.grade) {
          case 'safescoregrade1':
            emitionObj.comment = vm.safeScore.comment1;
            break;
          case 'safescoregrade2':
            emitionObj.comment = vm.safeScore.comment2;
            break;
          case 'safescoregrade3':
            emitionObj.comment = vm.safeScore.comment3;
            break;
          case 'safescoregrade4':
            emitionObj.comment = vm.safeScore.comment4;
            break;
          case 'safescoregrade5':
            emitionObj.comment = vm.safeScore.comment5;
            break;
        }

        vm.$emit('safeScoreVal', emitionObj);
      },
      deep: true
    },
    safeScoreData: {
      handler(newValue) {
        let vm = this;
        vm.safeScore.grade = newValue.rating
        switch (vm.safeScore.grade) {
          case 'safescoregrade1':
            vm.safeScore.comment1 = newValue.comment;
            break;
          case 'safescoregrade2':
            vm.safeScore.comment2 = newValue.comment;
            break;
          case 'safescoregrade3':
            vm.safeScore.comment3 = newValue.comment;
            break;
          case 'safescoregrade4':
            vm.safeScore.comment4 = newValue.comment;
            break;
          case 'safescoregrade5':
            vm.safeScore.comment5 = newValue.comment;
            break;
        }
      },
      deep: true
    }
  },
  mounted() {
    let vm = this;
    vm.safeScore.grade = vm.safeScoreData.rating
    switch (vm.safeScore.grade) {
      case 'safescoregrade1':
        vm.safeScore.comment1 = vm.safeScoreData.comment;
        break;
      case 'safescoregrade2':
        vm.safeScore.comment2 = vm.safeScoreData.comment;
        break;
      case 'safescoregrade3':
        vm.safeScore.comment3 = vm.safeScoreData.comment;
        break;
      case 'safescoregrade4':
        vm.safeScore.comment4 = vm.safeScoreData.comment;
        break;
      case 'safescoregrade5':
        vm.safeScore.comment5 = vm.safeScoreData.comment;
        break;
    }
  }
}
</script>

<template>
  <div class="columns is-mobile is-multiline is-vcentered">
    <table class="table is-striped is-fullwidth">
      <tbody>
      <tr>
        <th class="has-text-centered">Safe Score</th>
      </tr>
      <tr>
        <td>
          <div class="columns is-multiline is-vcentered">
            <div class="column is-one-fifth">
              <div class="fancy-input-group columns is-multiline is-vcentered"
                   v-bind:class="{'error-input':safeScoreRatingError}">
                <input v-bind:disabled="inputsDisabled" type="radio" name="safescoregrade" id="safescoregrade_1"
                       value="safescoregrade1"
                       class="fancy-input"
                       v-model="safeScore.grade"/>
                <label for="safescoregrade_1"
                       class="fancy-input-label column no-wrapping-label z-index-above top-margined">I</label>
              </div>
            </div>
            <div class="column is-two-fifths has-text-justified">
              <strong>Patient progressing as planned</strong><br>Treatment was successful. The surgery proceeded as
              planned. No additional medical intervention was necessary.
            </div>
            <div class="column is-two-fifths">
                <textarea class="textarea" placeholder="Comment here"
                          v-on:keyup="resize('safeScore1')"
                          ref="safeScore1"
                          v-model.trim="safeScore.comment1"
                          v-bind:class="{'error-input':safeScoreCommentError && safeScore.grade==='safescoregrade1'}"
                          v-bind:disabled="safeScore.grade!=='safescoregrade1' || inputsDisabled"></textarea>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="columns is-multiline is-vcentered">
            <div class="column is-one-fifth">
              <div class="fancy-input-group columns is-multiline is-vcentered"
                   v-bind:class="{'error-input':safeScoreRatingError}">
                <input v-bind:disabled="inputsDisabled" type="radio" name="safescoregrade" id="safescoregrade_2"
                       value="safescoregrade2"
                       class="fancy-input"
                       v-model="safeScore.grade"/>
                <label for="safescoregrade_2"
                       class="fancy-input-label column no-wrapping-label z-index-above top-margined">II</label>
              </div>
            </div>
            <div class="column is-two-fifths has-text-justified">
              <strong>Additional medication (that was not part of the original treatment plan) is now
                required</strong><br>Was there any complication resulting in pharmacological treatment or blood
              transfusion?
            </div>
            <div class="column is-two-fifths">
               <textarea class="textarea" placeholder="Comment here"
                         v-on:keyup="resize('safeScore2')"
                         ref="safeScore2"
                         v-model.trim="safeScore.comment2"
                         v-bind:class="{'error-input':safeScoreCommentError && safeScore.grade==='safescoregrade2'}"
                         v-bind:disabled="safeScore.grade!=='safescoregrade2' || inputsDisabled"></textarea>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="columns is-multiline is-vcentered">
            <div class="column is-one-fifth">
              <div class="fancy-input-group columns is-multiline is-vcentered"
                   v-bind:class="{'error-input':safeScoreRatingError}">
                <input v-bind:disabled="inputsDisabled" type="radio" name="safescoregrade" id="safescoregrade_3"
                       value="safescoregrade3"
                       class="fancy-input"
                       v-model="safeScore.grade"/>
                <label for="safescoregrade_3"
                       class="fancy-input-label column no-wrapping-label z-index-above top-margined">III</label>
              </div>
            </div>
            <div class="column is-two-fifths has-text-justified">
              <strong>Complications arose requiring surgical/endoscopic/radiological intervention?</strong><br>Was there
              any complication that resulted in surgical, radiological or endoscopic intervention – such as a catheter
              placement, dialysis or biopsy necessary?
            </div>
            <div class="column is-two-fifths">
               <textarea class="textarea" placeholder="Comment here"
                         v-on:keyup="resize('safeScore3')"
                         ref="safeScore3"
                         v-model.trim="safeScore.comment3"
                         v-bind:class="{'error-input':safeScoreCommentError && safeScore.grade==='safescoregrade3'}"
                         v-bind:disabled="safeScore.grade!=='safescoregrade3' || inputsDisabled"></textarea>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="columns is-multiline is-vcentered">
            <div class="column is-one-fifth">
              <div class="fancy-input-group columns is-multiline is-vcentered"
                   v-bind:class="{'error-input':safeScoreRatingError}">
                <input v-bind:disabled="inputsDisabled" type="radio" name="safescoregrade" id="safescoregrade_4"
                       value="safescoregrade4"
                       class="fancy-input"
                       v-model="safeScore.grade"/>
                <label for="safescoregrade_4"
                       class="fancy-input-label column no-wrapping-label z-index-above top-margined">IV</label>
              </div>
            </div>
            <div class="column is-two-fifths has-text-justified">
              <strong>Major life-threatening complications arising from surgery – such as organ failure</strong><br>Were
              there any major complications leading to ICU care – such as organ failure?
            </div>
            <div class="column is-two-fifths">
               <textarea class="textarea" placeholder="Comment here"
                         v-on:keyup="resize('safeScore4')"
                         ref="safeScore4"
                         v-model.trim="safeScore.comment4"
                         v-bind:class="{'error-input':safeScoreCommentError && safeScore.grade==='safescoregrade4'}"
                         v-bind:disabled="safeScore.grade!=='safescoregrade4' || inputsDisabled"></textarea>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="columns is-multiline is-vcentered">
            <div class="column is-one-fifth">
              <div class="fancy-input-group columns is-multiline is-vcentered"
                   v-bind:class="{'error-input':safeScoreRatingError}">
                <input v-bind:disabled="inputsDisabled" type="radio" name="safescoregrade" id="safescoregrade_5"
                       value="safescoregrade5"
                       class="fancy-input"
                       v-model="safeScore.grade"/>
                <label for="safescoregrade_5"
                       class="fancy-input-label column no-wrapping-label z-index-above top-margined">V</label>
              </div>
            </div>
            <div class="column is-two-fifths has-text-justified">
              <strong>Patient died</strong><br>Did the patient die?
            </div>
            <div class="column is-two-fifths">
                    <textarea class="textarea" placeholder="Comment here"
                              v-on:keyup="resize('safeScore5')"
                              ref="safeScore5"
                              v-model.trim="safeScore.comment5"
                              v-bind:class="{'error-input':safeScoreCommentError && safeScore.grade==='safescoregrade5'}"
                              v-bind:disabled="safeScore.grade!=='safescoregrade5' || inputsDisabled"></textarea>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>

.z-index-above {
  z-index: 1 !important;
}

.top-margined {
  margin-top: 20px;
}

</style>